import React, { useState } from "react";

//UI Material
import {
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  TextField,
} from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local components
import ContainedButton from "../basics/ContainedButton";
import ModalWindow from "../Modal";

//Material Icons
import { Upload } from "@mui/icons-material";

export default function SpecsDrawer({ open, setOpen, product, getData }) {
  // ==========> Component States <==========
  //State for product annotatios
  const [annotations, setAnnotations] = useState(product.annotations);
  //State for product specifications
  const [specifications, setSpecifications] = useState(product.specifications);
  //State for loading
  const [isLoading, setIsLoading] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  // ==========> Component Functions <==========
  //Function to set product annotations and specifications
  const setProductAnnotationsAndSpecs = async () => {
    setIsLoading(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/orders/set-product-specs",
        {
          productId: product.productId,
          annotations,
          specifications,
        }
      );
      const jsonResponse = await requestResponse.json();
      if (jsonResponse.status === "ok") {
        setModalText("Información del producto cambiada.");
        setModalDescription(
          `Se ha cambiado correctamente la información de este producto.`
        );
      } else {
        setModalText("No se pudo cambiar la información de este producto.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      setModalText("No se pudo cambiar la información de este producto.");
      setModalDescription(
        "Por favor, verifique su conexión a internet e inténtelo nuevamente."
      );
    }
    setModalOpen(true);
    setIsLoading(false);
    getData();
  };

  // ==========> Component <==========
  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12}>
          {typographyForSubtitles(
            "Especificaciones y Anotaciones",
            "secondary"
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={5}>
          <Stack alignItems="center">
            {typographyForText("Especificaciones", "bold")}
            <TextField
              multiline
              sx={{ width: "100%" }}
              value={specifications}
              onChange={(e) => setSpecifications(e.target.value)}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={5}>
          <Stack alignItems="center">
            {typographyForText("Anotaciones", "bold")}
            <TextField
              multiline
              sx={{ width: "100%" }}
              value={annotations}
              onChange={(e) => setAnnotations(e.target.value)}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ mt: 4 }}>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Stack direction="row" justifyContent="center" spacing={1}>
              <ContainedButton
                text="Cancelar"
                color="error"
                onClick={() => setOpen(false)}
              />
              <ContainedButton
                text="Guardar cambios"
                endIcon={<Upload />}
                onClick={() => {
                  setProductAnnotationsAndSpecs();
                }}
              />
            </Stack>
          )}
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
          setOpen(false);
        }}
      />
    </SwipeableDrawer>
  );
}
